<!--
* Change submit icon rather than color when "validated"?
* Still not happy with active style, full bg-1 doesn't look right...
  * Submit active icon is not pleasing either
* Check/match rgba values (0.8 or 0.9?) between elements
-->
<template>
  <form
    ref="searchInput"
    @keydown.prevent.enter
  >
    <div
      class="input"
      @click="toggleInput(true)"
    >
      <div
        :class="['input__icon', inputFocus ? 'input__icon--active' : '']"
        v-html="status === 'active' || status === 'loading' ? (status === 'loading' ? icons['loading'] : icons['active']) : icons['inactive']"
      />

      <vue-typed-js
        v-if="totalSelectedFilters === 0"
        :strings="['Robot', 'Robotics', 'Cobots', 'Collaborative Robots', 'Autonomous Mobile Robots', 'EV charging', 'Electric Vehicles', 'Electric Vehicles Market', 'Electric Vehicles Market in Germany', 'Global Battery Production', 'Sensor Market in World', 'AMR', 'IoT', 'AGV Market in Million USD', 'AGV Market in Million USD in Europe', 'AGV Market in Thousand', 'AGV Market in Thousand Units']"
        :smartBackspace="true"
        :typeSpeed="40"
        :backSpeed="15"
        :backDelay="1250"
        :loop="true"
        :showCursor="false"
        :attr="'placeholder'"
      >
        <input
          v-model="input"
          ref="searchInput"
          :class="['typing', 'input__element', inputFocus ? 'input__element--active' : '']"
          autocomplete="off"
          :autofocus="false"
          type="text"
          @focus="$event.target.select(); toggleInput(true)"
          @blur="toggleInput(false)"
          @keyup="inputChanged()"
        />
      </vue-typed-js>

      <input
        v-else
        v-model="input"
        ref="searchInput"
        :class="['typing', 'input__element', inputFocus ? 'input__element--active' : '']"
        autocomplete="off"
        :autofocus="false"
        type="text"
        placeholder="Start new search..."
        @focus="$event.target.select(); toggleInput(true)"
        @blur="toggleInput(false)"
        @keyup="inputChanged()"
      />

      <div
        :class="['input__submit', inputFocus ? 'input__submit--active' : '', inputFocus && input.length >= 2 ? 'input__submit--valid' : '']"
        @click="submit()"
      >
        <svg v-if="inputFocus && input.length >= 2" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm2 16v-2.625s-5.619.005-9 3.625c1.588-6.916 9-8.292 9-8.292v-2.708l5 5.021-5 4.979z"/></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M6 16c1.361-5.928 8-7 8-7v-2l4 3.982-4 4.018v-2s-5.102-.104-8 3zm-4-4c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10-10 4.486-10 10zm22 0c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12z"/></svg>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data () {
    return {
      status: 'inactive',
      inputFocus: false,
      icons: {
        inactive: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%"><path d="M21.172 24l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z"/></svg>',
        active: '<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 24 24" width="100%" height="100%"><path d="M21.172 24l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7zm-3-8c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"/></svg>',
        loading: '<svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 24 24" width="100%" height="100%"><path d="M13.818 16.646c-1.273.797-2.726 1.256-4.202 1.354l-.537-1.983c2.083-.019 4.132-.951 5.49-2.724 2.135-2.79 1.824-6.69-.575-9.138l-1.772 2.314-1.77-6.469h6.645l-1.877 2.553c3.075 2.941 3.681 7.659 1.423 11.262l7.357 7.357-2.828 2.828-7.354-7.354zm-11.024-1.124c-1.831-1.745-2.788-4.126-2.794-6.522-.005-1.908.592-3.822 1.84-5.452 1.637-2.138 4.051-3.366 6.549-3.529l.544 1.981c-2.087.015-4.142.989-5.502 2.766-2.139 2.795-1.822 6.705.589 9.154l1.774-2.317 1.778 6.397h-6.639l1.861-2.478z"/></svg>'
      }
    }
  },
  computed: {
    input: {
      get () {
        return this.$store.getters['search/getInput']
      },
      set (value) {
        this.$store.dispatch('search/setInput', value)
      }
    },
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    },
    totalSelectedFilters () {
      let total = 0

      if (this.selectedFilters) {
        for (const [key, value] of Object.entries(this.selectedFilters)) {
          if (this.selectedFilters[key] && this.selectedFilters[key].length > 0) {
            total += this.selectedFilters[key].length
          }
        }
      }

      return total
    }
  },
  methods: {
    inputChanged () {
      if (event.keyCode === 13) {
        this.$emit('submitted')
      } else {
        this.$root.$emit('changed')
      }
    },
    submit () {
      this.$emit('submitted')
    },
    toggleInput (value) {
      if (value === true) {
        this.status = 'active'
        this.inputFocus = true
      } else {
        this.status = 'inactive'
        this.inputFocus = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.input {
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 32px;
  margin: 0 auto;

  @media screen and (min-width: $breakpointLg) {
    height: 34px;
  }

  &:hover {
    .input__element:not(.input__element--active) {
      background-color: lighten($bg-2, 2);
    }

    ::placeholder {
      color: rgba($white, 0.9);
    }

    .input__icon:not(.input__icon--active) {
      fill: rgba($white, 0.9);
      transform: rotate(12deg);
    }

    .input__submit:not(.input__submit--active) {
      border-color: $bg-1;

      svg {
        fill: rgba($white, 0.9);
      }
    }
  }

  &__icon {
    position: absolute;
    z-index: 30;
    top: 0px;
    left: 0px;
    width: 18px;
    height: 18px;
    padding: 7px 9px;
    fill: rgba($white, 0.5);
    transition: fill .2s ease-in-out, transform .2s ease-in-out;

    @media screen and (min-width: $breakpointLg) {
      width: 20px;
      height: 20px;
    }

    &--active {
      fill: rgba($white, 0.9);
    }
  }

  &__submit {
    position: absolute;
    z-index: 50;
    width: 18px;
    height: 18px;
    padding: 5px;
    top: 0px;
    right: 0px;
    fill: rgba($white, 0.5);
    background-color: $bg-2;
    border-radius: 999px;
    border: 2px solid $bg-1;
    cursor: pointer;

    @media screen and (min-width: $breakpointLg) {
      width: 20px;
      height: 20px;
    }

    svg {
      transition: transform 0.1s ease-out;
    }

    &:hover svg {
      transform: scale(1.2);

      @media screen and (min-width: $breakpointLg) {
        transform: scale(1.175);
      }
    }

    &:active svg {
      transform: scale(1);
    }

    &--active {
      background-color: $bg-1;
      border: 2px solid $bg-4 !important;
      fill: rgba($white, 0.9);
      padding: 7px;
      top: -2px;
      right: -2px;

      svg {
        fill: rgba($white, 0.8);
      }
    }

    &--valid svg {
      //fill: $blue !important;
    }
  }

  &__element {
    @include font('content--md', $white);
    position: absolute;
    z-index: 20;
    top: 0px;
    left: 0px;
    width: calc(100% - 78px);
    height: 28px;
    padding: 0px 40px 0px 34px;
    outline: 0;
    text-align: left;
    border-radius: 999px;
    border: 2px solid $bg-1;
    background-color: $bg-2;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg', $white);
      width: calc(100% - 84px);
      height: 30px;
      padding: 0px 40px 0px 40px;
    }

    &::placeholder {
      color: rgba($white, 0.5);
    }

    &--active {
      background-color: $bg-1;
      border: 2px solid $bg-1;
      color: $white;
    }
  }
}

:-webkit-autofill {
  box-shadow: 0 0 0 100rem $bg-1 inset !important;
  -webkit-text-fill-color: $white !important;
}

</style>
